import React from "react";
import parse, {
  Element,
  domToReact,
  HTMLReactParserOptions,
} from "html-react-parser";
import { safeArticleLink } from "@/blog/article-service";
import RichTextContent, {
  hasRichTextMarker,
} from "@/components/ui/RichTextContent";

const allowed = new Set([
  "p",
  "h2",
  "h3",
  "h4",
  "strong",
  "em",
  "b",
  "i",
  "u",
  "s",
  "a",
  "ul",
  "ol",
  "li",
  "blockquote",
  "br",
  "hr",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "code",
  "pre",
  "span",
]);
export function ArticleRichText({
  html,
  idPrefix = "article",
  extendedHeadings = false,
}: {
  html: string;
  idPrefix?: string;
  /** Image/text rows also support the editorial subheadings h5 and h6. */
  extendedHeadings?: boolean;
}) {
  if (hasRichTextMarker(html))
    return <RichTextContent html={html} idPrefix={idPrefix} />;
  let heading = 0;
  const options: HTMLReactParserOptions = {
    replace: (node) => {
      if (!(node instanceof Element)) return;
      if (
        !allowed.has(node.name) &&
        !(extendedHeadings && /^h[56]$/.test(node.name))
      )
        return React.createElement(React.Fragment);
      const attrs: Record<string, string> = {};
      if (node.name === "a") {
        const href = safeArticleLink(node.attribs.href);
        if (href) attrs.href = href;
      }
      if ((extendedHeadings ? /^h[23456]$/ : /^h[234]$/).test(node.name)) {
        attrs.id = `${idPrefix}-heading-${heading++}`;
        if (!extendedHeadings) attrs.className = "primary-font";
      }
      if (node.name === "br" || node.name === "hr") {
        return React.createElement(node.name, attrs);
      }
      return React.createElement(
        node.name,
        attrs,
        domToReact(node.children as Parameters<typeof domToReact>[0], options),
      );
    },
  };
  return React.createElement(React.Fragment, null, parse(html, options));
}
